import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CalculateIcon from "@mui/icons-material/Calculate";
import TimerComponent from "../../../components/TimerComponent";
import Calculator from "../../../components/Calculator";
import useExamHeaderStyles from "../testStyle/gateStyle/examHeaderStyle";
import { useQuestionSection } from "../../../hooks/default/useQuestionSection";
import { ReactComponent as InfoIcon } from "../../../images/Info.svg";
import { ReactComponent as CandidateIcon } from "../../../images/candidateicon.svg";
import HoverInfo from "./HoverInfo";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { useQuestionRecord } from "../../../context/QuestionRecord";
import { useQuestionNavigatorGate } from "../../../hooks/useQuestionNavigatorGate";
import TimerComponentSubject from "../../../components/TimerComponentSubject";
import calculatr from "../../../images/calculatr.png";
import CloseIcon from "@mui/icons-material/Close";
import DraggablePaper from "../../../components/DraggablePaper";
// import { ReactComponent as CalculatorIcon } from "../../../images/Calculator.svg";

const WhiteTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "#000",
    fontSize: "0.875rem",
    border: "1px solid #ddd",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
}));

const ExamHeader = ({
  subjectNames,
  currentQuestion,
  currentSubject,
  handleQuestionChange,
  sectionNames,
  currentSection,
  questionData,
  setCurrentQuestion,
  subjectId,
  negativeMark,
  mark,
  setActiveSubjectId,
  setActiveSectionId,
  activeSubjectId,
  activeSectionId,
  desktopOpen,
  isMobile,
  setSscTimeUp,
  setIsOnSubmit,
  questionType,
  allQuestion,
}) => {
  const theme = useTheme();
  const [openCalculator, setOpenCalculator] = useState(false);
  const classes = useExamHeaderStyles();
  const subjectWrapperRef = useRef(null);
  const sectionWrapperRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [buttonClick, setButtonClick] = useState(false);
  const [hoveredSection, setHoveredSection] = useState(null);
  const [hoveredSubject, setHoveredSubject] = useState(null);

  const { getSectionSummary } = useQuestionRecord();
  const subjectWise = sessionStorage.getItem("subject_wise");

  const [info, setInfo] = useState({
    name: "info",
    data: [
      {
        type: "attempted",
        number: "1",
        name: "Attempted",
      },
      {
        type: "notAnswered",
        number: "2",
        name: "Not Answered",
      },
      {
        type: "notVisited",
        number: "3",
        name: "Not Visited",
      },
      {
        type: "marked",
        number: "4",
        name: "Marked",
      },
      {
        type: "markedWithAnswered",
        number: "5",
        name: "Answered and Marked for Review",
      },
    ],
  });

  const sectionsN = Array.isArray(sectionNames[currentIndex])
    ? sectionNames[currentIndex]
    : [];

  const currentSubjectSections = Array.isArray(currentSection[currentIndex])
    ? currentSection[currentIndex]
    : [];

  const {
    setIsTimeUp,
    showSubmitModal,
    handleCloseSubmitModal,
    handleFinalSubmit,
    isTimeUp,
    stats,
    submitError,
    countdownTime,
    finalSubmitChecked,
    handleFinalSubmitCheck,

    nextSubjectCounter,
    nextSubject,
    setIsSubjectTimeUp,
    isSubjectTimeUp,
    isSubjectSubmit,
  } = useQuestionSection({
    questionData,
    currentQuestion,
    setCurrentQuestion,
    subjectId,
    activeSectionId,
    activeSubjectId,
  });

  const handleOpenCalculator = () => {
    setOpenCalculator(true);
  };

  const handleCloseCalculator = () => {
    setOpenCalculator(false);
  };

  const scrollSubjects = (direction) => {
    const container = subjectWrapperRef.current;
    if (container) {
      const scrollAmount = 200;
      if (direction === "left") {
        container.scrollLeft -= scrollAmount;
      } else {
        container.scrollLeft += scrollAmount;
      }
    }
  };

  const scrollSection = (direction) => {
    const container = sectionWrapperRef.current;
    if (container) {
      const scrollAmount = 200;
      if (direction === "left") {
        container.scrollLeft -= scrollAmount;
      } else {
        container.scrollLeft += scrollAmount;
      }
    }
  };

  useEffect(() => {
    let totalQuestion = 0;

    if (hoveredSection) {
      allQuestion.map((question) => {
        if (
          Number(question.subject_id) === Number(activeSubjectId) &&
          Number(question.section_id) === Number(hoveredSection.id)
        ) {
          totalQuestion += 1;
        }
      });

      const { answered, marked, markedWithAnswered, notAnswered, notVisited } =
        getSectionSummary(activeSubjectId, hoveredSection.id, totalQuestion);
      setInfo((prev) => ({
        ...prev,
        name: hoveredSection.name,
        data: [
          {
            type: "attempted",
            number: answered,
            name: "Attempted",
          },
          {
            type: "notAnswered",
            number: notAnswered,
            name: "Not Answered",
          },
          {
            type: "notVisited",
            number: notVisited,
            name: "Not Visited",
          },
          {
            type: "marked",
            number: marked,
            name: "Marked",
          },
          {
            type: "markedWithAnswered",
            number: markedWithAnswered,
            name: "Answered and Marked for Review",
          },
        ],
      }));
    }
  }, [hoveredSection]);
  useEffect(() => {
    let totalQuestion = 0;

    if (hoveredSubject) {
      allQuestion.map((question) => {
        if (Number(question.subject_id) === Number(hoveredSubject.id)) {
          totalQuestion += 1;
        }
      });

      const { answered, marked, markedWithAnswered, notAnswered, notVisited } =
        getSectionSummary(hoveredSubject.id, null, totalQuestion);
      setInfo((prev) => ({
        ...prev,
        name: hoveredSubject.name,
        data: [
          {
            type: "attempted",
            number: answered,
            name: "Attempted",
          },
          {
            type: "notAnswered",
            number: notAnswered,
            name: "Not Answered",
          },
          {
            type: "notVisited",
            number: notVisited,
            name: "Not Visited",
          },
          {
            type: "marked",
            number: marked,
            name: "Marked",
          },
          {
            type: "markedWithAnswered",
            number: markedWithAnswered,
            name: "Answered and Marked for Review",
          },
        ],
      }));
    }
  }, [hoveredSubject]);

  useEffect(() => {
    currentSection.map((arrays, index) => {
      const firstElement = arrays[0];
      const lastElement = arrays[arrays.length - 1];
      const isBetween =
        currentQuestion + 1 >= firstElement &&
        currentQuestion + 1 <= lastElement;

      if (isBetween) {
        setCurrentIndex(index);
      }
    });
  }, []);

  useEffect(() => {
    if (buttonClick) {
      setActiveSectionId(sectionsN[currentQuestion]?.section_id);
      setButtonClick(false);
    }
  }, [currentIndex]);

  useEffect(() => {
    const subjectCurrentIndex = subjectNames.findIndex(
      (item) => item.subject_id === activeSubjectId
    );
    setCurrentIndex(subjectCurrentIndex);
    setCurrentQuestion(0);
  }, [activeSectionId]);

  useEffect(() => {
    if (sectionWrapperRef.current && activeSectionId) {
      // Find the active button element
      const activeButton = sectionWrapperRef.current.querySelector(
        `.${classes.activeSectionTab}`
      );

      if (activeButton) {
        // Calculate scroll position
        const container = sectionWrapperRef.current;
        const buttonLeft = activeButton.offsetLeft;
        const buttonWidth = activeButton.offsetWidth;
        const containerWidth = container.offsetWidth;

        // Calculate the scroll position to center the active button
        const scrollTo = buttonLeft - containerWidth / 2 + buttonWidth / 2;

        // Smoothly scroll to the position
        container.scrollTo({
          left: scrollTo,
          behavior: "smooth",
        });
      }
    }
  }, [activeSectionId]);

  return (
    <Box>
      {/* Top navigation bar */}
      <Box className={classes.topNavBar}>
        <IconButton onClick={() => scrollSubjects("left")}>
          <ArrowBackIosNewIcon className={classes.arrowBtn} fontSize="small" />
        </IconButton>

        <Box className={classes.subjectWrapper} ref={subjectWrapperRef}>
          {subjectNames?.map((subject, sectionIndex) => {
            const questionIndex = currentSubject[sectionIndex];
            const isBetween =
              currentQuestion >= questionIndex &&
              currentQuestion <
                questionIndex + (currentSubject[sectionIndex + 1] || 0);

            return (
              <Button
                onClick={() => {
                  if (subjectWise === "no") {
                    handleQuestionChange(0);
                    setCurrentIndex(sectionIndex);
                    setActiveSubjectId(subject?.subject_id);
                    setButtonClick(true);
                  }
                }}
                className={
                  subject?.subject_id === activeSubjectId
                    ? classes.activeSubjectButton
                    : classes.inactiveSubjectButton
                }
              >
                <div
                  style={{
                    padding: "0 10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  {subject.name}
                  <WhiteTooltip title={<HoverInfo info={info} />}>
                    <InfoIcon
                      fontSize="small"
                      onMouseEnter={() =>
                        setHoveredSubject({
                          id: subject.subject_id,
                          name: subject.name,
                        })
                      }
                      onMouseLeave={() => setHoveredSubject(null)}
                    />
                  </WhiteTooltip>{" "}
                </div>
              </Button>
            );
          })}
        </Box>

        <Box flexGrow={1} />

        <IconButton onClick={() => scrollSubjects("right")}>
          <ArrowForwardIosIcon className={classes.arrowBtn} fontSize="small" />
        </IconButton>

        {/* <CalculatorIcon /> */}
        <img
          src={calculatr}
          style={{ height: 30, cursor: "pointer" }}
          onClick={handleOpenCalculator}
          alt=""
        />
      </Box>

      <Dialog
        open={openCalculator}
        onClose={handleCloseCalculator}
        hideBackdrop // ✅ removes background blocker
        disableEnforceFocus // ✅ allows background focus
        disableAutoFocus
        disableRestoreFocus
        PaperComponent={DraggablePaper}
        PaperProps={{
          sx: {
            width: "300px",
            maxWidth: "300px",
            pointerEvents: "auto", // dialog clickable
          },
        }}
        sx={{
          pointerEvents: "none", // allow clicks to pass through
        }}
      >
        <DialogTitle id="draggable-dialog-title" sx={{ cursor: "move", p: 2 }}>
          Calculator
          <IconButton
            onClick={handleCloseCalculator}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Calculator />
        </DialogContent>
      </Dialog>

      {/* Section + time left */}
      <Box className={classes.sectionTimeContainer}>
        <Typography fontWeight="bold">Section</Typography>
        <Typography fontWeight="bold">
          Time Left :{" "}
          <span className={classes.timeLeft}>
            {sessionStorage.getItem("subject_wise") === "yes" ? (
              <TimerComponentSubject
                setIsTimeUp={setSscTimeUp}
                showSubmitModal={showSubmitModal}
                handleCloseSubmitModal={handleCloseSubmitModal}
                handleFinalSubmit={handleFinalSubmit}
                isTimeUp={isTimeUp}
                stats={stats}
                submitError={submitError}
                countdownTime={countdownTime}
                finalSubmitChecked={finalSubmitChecked}
                onFinalSubmitCheck={handleFinalSubmitCheck}
                activeSubjectId={activeSubjectId}
                nextSubjectCounter={nextSubjectCounter}
                nextSubject={nextSubject}
                isSubjectSubmit={isSubjectSubmit}
                subjectNames={subjectNames}
                setIsSubjectTimeUp={setIsSubjectTimeUp}
                isSubjectTimeUp={isSubjectTimeUp}
                setIsOnSubmit={setIsOnSubmit}
              />
            ) : (
              <TimerComponent
                setIsTimeUp={setSscTimeUp}
                setIsOnSubmit={setIsOnSubmit}
                showSubmitModal={showSubmitModal}
                handleCloseSubmitModal={handleCloseSubmitModal}
                handleFinalSubmit={handleFinalSubmit}
                isTimeUp={isTimeUp}
                stats={stats}
                submitError={submitError}
                countdownTime={countdownTime}
                finalSubmitChecked={finalSubmitChecked}
                onFinalSubmitCheck={handleFinalSubmitCheck}
              />
            )}
          </span>
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          "& .MuiButtonBase-root": {
            padding: "4px 0px !important",
          },
        }}
      >
        {}
        <IconButton onClick={() => scrollSection("left")}>
          <ArrowBackIosNewIcon className={classes.arrowBtn} fontSize="small" />
        </IconButton>

        {/* Section tabs */}
        <Box
          className={`${classes.sectionTabsContainer} 
           ${!desktopOpen || isMobile ? classes.wFull : classes.wHaf}
          `}
          ref={sectionWrapperRef}
        >
          {sectionsN.map((section, sectionIndex) => {
            const start =
              sectionIndex === 0 ? 0 : currentSubjectSections[sectionIndex - 1];
            const end = currentSubjectSections[sectionIndex];

            const isBetween = currentQuestion >= start && currentQuestion < end;

            return (
              <Button
                key={section.section_id}
                onClick={() => {
                  handleQuestionChange(0);
                  setActiveSectionId(section.section_id);
                }}
                className={
                  section.section_id === activeSectionId
                    ? classes.activeSectionTab
                    : classes.inactiveSectionTab
                }
                // style={{ position: "relative" }} // important for HoverInfo positioning
              >
                <span
                style={{padding:'0px 5px',display:'flex',gap:'8px',alignItems:'center'}}
                >
                  {section.name}
                  {/* <span
                  onMouseEnter={() => setHoveredSection(section.section_id)}
                  onMouseLeave={() => setHoveredSection(null)}
                  style={{
                    marginLeft: 4,
                    display: "inline-flex",
                    position: "relative",
                  }} 
                >
                  <InfoIcon fontSize="small" />
                  {hoveredSection === section.section_id && (
                    <HoverInfo info={section.name} />
                  )}
                </span> */}
                  <WhiteTooltip title={<HoverInfo info={info} />}>
                    <InfoIcon
                      fontSize="small"
                      onMouseEnter={() =>
                        setHoveredSection({
                          id: section.section_id,
                          name: section.name,
                        })
                      }
                      onMouseLeave={() => setHoveredSection(null)}
                    />
                  </WhiteTooltip>
                </span>
              </Button>
            );
          })}
        </Box>
        <IconButton onClick={() => scrollSection("right")}>
          <ArrowForwardIosIcon className={classes.arrowBtn} fontSize="small" />
        </IconButton>
      </Box>

      {/* Question details */}
      <Box className={classes.questionDetailsContainer}>
        <Typography sx={{ fontSize: "14px" }} color="black" fontWeight="bold">
          Question Type : {questionType}
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Typography sx={{ fontSize: "14px" }}>
            Mark for correct answer:{" "}
            <span className={classes.positiveMark}>{mark}</span>
          </Typography>
          <Typography sx={{ fontSize: "14px" }}>
            Negative Mark:{" "}
            <span className={classes.negativeMark}>{negativeMark}</span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ExamHeader;
